<template>
 <div id="admin">
   <menu-admin/>
    <section class="int-form" style="margin-top: 30px;">
      <div class="container">

        <div class="card card-primary  d-print-none">
            
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <input type="date" class="form-control" name="dates" v-model="start_date" /> 
                    </div>

                    <div class="col-md-3">                        
                        <input type="date" class="form-control" name="dates" v-model="end_date" /> 
                    </div>

                     <div class="col-md-2">                        
                        <select class="form-control" @change="changeDate()" name="status_type" v-model="status_type">
                                <option value="1"> Assinaturas </option>
                                <option value="2"> Renovações </option>
                                <option value="3"> Compras </option>
                        </select>                        
                    </div>

                    <div class="col-md-2">                        
                        <button type="button" @click="changeDate()" class="btn btn-primary btn-block" 
                                >Pesquisar</button>
                    </div>

                    <div class="col-md-2">
                                       
                        <a class="btn btn-warning text-white " 
                                href="javascript:window.print();"
                                >Imprimir</a>
                        
                    </div>

                </div>

            </div>

        </div>

        <div class="row">
          <div class="col-12">
                <h5 style="margin-top:20px"> {{ status_descricao }}
                    <i v-if="start_date && end_date">entre {{ start_date_formated }} e {{ end_date_formated }}</i>
                </h5><br/>
            </div>
        </div>
            

    <div class="row">
        <div class="col-12">
          

            <table class="table table-bordered table-sm table-hover" style="background: white; font-size: 0.8em">
            <tr v-show="!signatures.length">
                <td class="text-center" colspan="4">Nenhuma publicação encontrada</td>
            </tr>
            <thead v-show="signatures.length">
            <tr>
                <th class="text-center" width="100" scope="col">Data</th>
                <th class="text-center" width="100" scope="col">Pedido</th>                
                <th>Cliente</th>
                <th class="text-center" width="150">Telefone</th>
                <th>Publicação</th>
                <th>Prefixo</th>
                <th class="text-center" width="100">Expiração</th>
            </tr>
            </thead>
            <tbody v-show="signatures.length">
                <tr v-for="signature in signatures" v-bind:key="signature.id">
                
                <td class="text-center">{{signature.order.date | formatDate}}</td>
                <td class="text-center">#{{signature.order.id}}</td>                
                <td>
                    <span v-if="signature.profile.person_or_company">{{signature.profile.company_name}}</span>
                    <span v-else>{{signature.profile.name}}</span>
                </td>
                <td class="text-center">{{signature.profile.phone}}</td>
                <td>{{signature.publication.name}}</td>
                <td class="text-center">{{signature.airplane_prefix}}</td>    
                <td class="text-center">{{ signature.due | formatDate }}</td>
                </tr>
                <tr v-show="!signatures.length"><td colspan="5" class="text-center">Nenhum resultado pode ser encontrado</td></tr>
            </tbody>
        </table>


        </div>
      </div>

      </div>

    </section>
   <footer-admin/>
  </div>
</template>

<script>

  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import mixins from "../../helpers/mixins"
  import reports from "../../api/reports"
  import moment from 'moment'

  export default {
    name: "SignaturesOrders",
    mixins: [mixins],
    data(){
      return {
        signatures: {},
        start_date: '',
        end_date: '',
        status_type : null, 
        status_descricao: '', 
        total: 0
      }
    },
    components: { menuAdmin, footerAdmin },
    methods: { 

      getSignatures(start, end, sta){
       
        start = moment(this.start_date).format('YYYY-MM-DD');
        end = moment(this.end_date).format('YYYY-MM-DD');
        sta = this.status_type;

        this.status_descricao = "Assinaturas";
        if (sta == "2")
            this.status_descricao = "Renovações"; 
        else if (sta == "3")
            this.status_descricao = "Compras"; 

        reports.get_signatures_orders(start, end, sta).then((response)  =>  {     
            
            console.log(response)
          this.signatures = response.data
        }).catch(errors => { this.formErrors(errors) })
      },

      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      changeDate(){
        this.getSignatures()
      }
    },
    computed: {
      start_date_formated: function () {
        return moment(this.start_date).format('DD/MM/YYYY');
      },
      end_date_formated: function () {
        return moment(this.end_date).format('DD/MM/YYYY');
      }
    },
    mounted(){ 

      
      //this.start_date = new Date(moment().subtract(30, "days").format('YYYY-MM-DD'))
      //this.end_date = new Date()

      this.start_date = moment().startOf('month').format('YYYY-MM-DD');
      this.end_date   = moment().endOf('month').format('YYYY-MM-DD');

      this.status_type = this.$route.params.status_type

    
      //this.status_type = 1
      this.status_descricao = 'Assinaturas'
      this.getSignatures()
    }
  }

</script>
